import React, { Component } from 'react';
import Footer from './components/Footer/Footer';
import Links from './components/Links/Links';

export default class Index extends Component {
    render() {
        const { i18nParticipation, showReportOverlay, branding, classes } = this.props;

        return (
            <Footer
                i18nParticipation={ i18nParticipation }
                branding={ branding }
                classes={ classes }
            >
                <Links
                    i18nParticipation={ i18nParticipation }
                    showReportOverlay={ showReportOverlay }
                />
            </Footer>
        );
    }
}
